import React, { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { GenericDetailPage } from '../../../components/generic';
import { buildCrewLookupModuleConfig, getDetailSections, getStatusBadges, type CrewLookupRouteOptions } from './config';
import { CrewLookupKindContext, useCrewLookupKind } from './CrewLookupKindContext';
import { getCrewLookupDef, type CrewLookupDef } from './registry';
import { useCrewLookupItem, type CrewLookupItem } from './useData';
import ManningAgentPortalPanel from './ManningAgentPortalPanel';

function useCrewLookupDetailData(id: number) {
  return useCrewLookupItem(useCrewLookupKind(), id);
}

const DetailInner: React.FC<{ def: CrewLookupDef; routes?: CrewLookupRouteOptions }> = ({ def, routes }) => {
  const moduleConfig = useMemo(() => buildCrewLookupModuleConfig(def, routes), [def, routes]);
  const { id } = useParams<{ id: string }>();
  const agentId = id ? Number(id) : NaN;

  return (
    <CrewLookupKindContext.Provider value={def.kind}>
      <GenericDetailPage<CrewLookupItem>
        useData={useCrewLookupDetailData as any}
        config={{
          ...moduleConfig,
          getDetailSections: (item: CrewLookupItem, formatDate: (s?: string) => string) =>
            getDetailSections(def, item, formatDate),
          getStatusBadges,
        } as any}
      />
      {def.kind === 'manning-agents' &&
      routes?.recordBase === '/admin/manning-agents' &&
      Number.isFinite(agentId) &&
      agentId > 0 ? (
        <div className="mt-6 px-4 pb-8 sm:px-6 lg:px-8">
          <ManningAgentPortalPanel agentId={agentId} />
        </div>
      ) : null}
    </CrewLookupKindContext.Provider>
  );
};

const Detail: React.FC<{ kind?: string; routes?: CrewLookupRouteOptions }> = ({ kind: kindProp, routes }) => {
  const { kind: kindParam } = useParams<{ kind: string }>();
  const def = getCrewLookupDef(kindProp ?? kindParam);
  if (!def) return <Navigate to="/parameters/countries" replace />;
  return <DetailInner def={def} routes={routes} />;
};

export default Detail;
